import React, { useState, useEffect } from "react";
import { useLocation } from "@reach/router";
import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";
import { motion, useAnimation } from "framer-motion";

const Aside = ({ isOpen }) => {
  // Control animation
  const controls = useAnimation();

  // Animation variants
  const itemVariants = {
    open: { opacity: 1, y: 0, transition: { duration: 0.75 } },
    closed: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };

  // Effect to trigger animation when isOpen changes
  useEffect(() => {
    if (isOpen) {
      controls.start("open");
    } else {
      controls.start("closed");
    }
  }, [isOpen, controls]);

  return (
    <aside
      className={`aside-nav flex flex-col justify-end ${
        isOpen ? "active" : ""
      }`}
    >
      <nav className="flex h-full w-full items-center justify-center">
        <motion.ul
          className="menu-list"
          initial="closed"
          animate={controls}
          variants={{ open: { transition: { staggerChildren: 0.2 } } }}
        >
          <motion.li variants={itemVariants}>
            <Link to="/" activeClassName="active">
              Home
            </Link>
          </motion.li>
          <motion.li variants={itemVariants}>
            <Link to="/about" activeClassName="active">
              About
            </Link>
          </motion.li>
          <motion.li variants={itemVariants}>
            <Link to="/contact" activeClassName="active">
              Contact
            </Link>
          </motion.li>
        </motion.ul>
      </nav>
    </aside>
  );
};

const Header = () => {
  const data = useStaticQuery(graphql`
    query SiteInfo {
      strapiGlobalProduction {
        siteLogo {
          localFile {
            url
          }
        }
      }
    }
  `);

  const [navOpen, setNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header
        className={`fixed w-full top-0 z-50 ${isScrolled ? "scrolled" : ""}`}
      >
        <div className="flex items-center justify-between px-6 md:px-6 lg:px-[2vw] py-4 md:pt-6">
          {location.pathname === "/" || location.pathname === "/about" ? (
            <div id="logo" className="">
              <Link to={`/`} onClick={() => window.location.reload()}>
                <img
                  src={data.strapiGlobalProduction.siteLogo.localFile.url}
                  alt="PPT4U Production"
                  className={`transition-all duration-300 ${
                    isScrolled ? "w-20 md:w-24 xl:w-28" : "w-20 md:w-24 xl:w-36"
                  }`}
                />
              </Link>
            </div>
          ) : (
            <div>
              <Link to={`/`}>
                <img
                  src={data.strapiGlobalProduction.siteLogo.localFile.url}
                  alt="PPT4U Production"
                  className={`w-24 md:w-28 2xl:w-36 transition-all duration-300`}
                />
              </Link>
            </div>
          )}

          <button
            id="hamburger"
            className={`menu-toggler ${navOpen ? "active" : ""}`}
            onClick={() => setNavOpen(!navOpen)}
            data-cursor-stick="#hamburger"
          >
            <span className="line line-1"></span>
            <span className="line line-2"></span>
            <span className="line line-3"></span>
          </button>
        </div>
      </header>
      <Aside isOpen={navOpen} />
    </>
  );
};

export default Header;
